module.exports = __webpack_public_path__ + "img/meituan.3bb81bcf.png";